import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Chart from './Chart'
import AlertCount from './AlertCount';
import LatestResult from '../LatestResultTable';
import { styles } from '../../styles/card-styles';

function MainCardContent(props) {
  const { classes, data, unit, alerts, rangeSetting, chartProps, panel } = props;
  return (
    <div className={classes.contentContainer}>
      <div className={classes.yAxisLabel}>
        <LatestResult data={data} unit={unit} />
      </div>
      <Chart times={data} unit={unit} chartProps={chartProps} />
      <AlertCount alerts={alerts} range={rangeSetting} />
    </div>           
  )
}

MainCardContent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainCardContent);


// WEBPACK FOOTER //
// ./src/components/ChartCard/MainCardContent.js